<template>
    <section class="csv-upload">
        <Link :href="route('csv-upload')" class="title-s csv-upload__backCta">Back to CSV Uploader</Link>
        <h1 class="headline-l">CSV Upload results</h1>
        <div class="csv-upload__content-wrapper">
            <div class="summary">
                <div class="summary-item"><h5 class="label"> Total Rows Found in CSV </h5> <span class="count">{{ total_rows_in_csv }}</span></div>
                <div class="summary-item"><h5 class="label"> Total Lines Found in CSV </h5><span class="count">{{ total_lines_in_csv }} (multiple rows of the same UPC are grouped together)</span></div>
                <div class="summary-item"><h5 class="label"> Total Orders Found </h5><span class="count">{{ total_orders_in_csv }}</span></div>
                <div class="summary-item"><h5 class="label"> Total Lines Found in System </h5><span class="count">{{ total_lines_in_system }}</span></div>
                <div class="summary-item"><h5 class="label"> Total Items With No Inventory </h5><span class="count">{{ no_inventory_items.length }} (These Items Will Be Skipped)</span></div> 
                <table class="no-inventory-items" v-if="no_inventory_items.length">
                    <tr class="no-inventory-title">
                        <td colspan="3">
                            <div class="no-inventory-title-wrapper">
                            <BlockIcon alt="carrets right"/> 
                                <span>The following items has no inventory available and will be skipped during the import</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="no-inventory-header">
                        <td>UPC</td>
                        <td>Qty</td>
                        <td>PO_Number</td>
                    </tr>
                    <tr v-for="no_inventory_item in no_inventory_items" class="no-inventory-item" :key="no_inventory_item.upc">
                        <td>{{no_inventory_item.upc}}</td>
                        <td>{{no_inventory_item.quantity}}</td>
                        <td>{{no_inventory_item.po_number}}</td>
                    </tr>
                </table>

                <table class="no-inventory-items" v-if="not_existing_items.length">
                    <tr class="no-inventory-title">
                        <td colspan="3">
                            <div class="no-inventory-title-wrapper">
                                <BlockIcon alt="carrets right" /> 
                                <span>The following items could not be found and will be skipped during the import</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="no-inventory-header">
                        <td>UPC</td>
                        <td>Qty</td>
                        <td>PO_Number</td>
                    </tr>
                    <tr v-for="not_existing_item in not_existing_items" class="no-inventory-item" :key="not_existing_item.upc">
                        <td>{{not_existing_item.upc}}</td>
                        <td>{{not_existing_item.quantity}}</td>
                        <td>{{not_existing_item.po_number}}</td>
                    </tr>
                </table>

                <h5 class="continue-ask">Do you want to continue anyway?</h5>
                <div class="continue-buttons"> 
                    <Link
                        :href="route('csv-upload')"
                        as="button"
                        class="secondary small" aria-label="No"
                    >
                        NO
                        <div aria-label="hidden" class="icon">
                            <CarretsBlackIcon alt="arrow right" />
                        </div>
                    </Link>
                    <Link
                        @click.prevent="continueUploadCsv"
                        as="button" :disabled="form.processing"
                        class="primary small" aria-label="Yes"
                    >
                        YES
                        <div aria-label="hidden" class="icon">
                            <CarretsBlackIcon alt="carrets right" />
                        </div>
                    </Link>
                </div>
            </div>
            <div class="csv-upload__content-wrapper__table">
                <CSVUploadHelp />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import { Link } from "@inertiajs/vue3";
    import { useForm } from '@inertiajs/vue3';
    import { useSettingsStore } from "@/store/settings";
    import CSVUploadHelp from '@/components/CSVUploadHelp.vue';
    import { inject } from 'vue';
    import BlockIcon from '@icons/icons8-block.svg';
    import CarretsBlackIcon from '@icons/carrets-black.svg';
    let { setOverlayMessage } = useSettingsStore();
    let route = inject("route");
    let { 
        filepath, total_rows_in_csv = 0, 
        total_lines_in_csv = 0, 
        total_orders_in_csv = 0, 
        total_lines_in_system = 0, 
        no_inventory_items = [],
        not_existing_items = [],
        autocheckout
    } = defineProps({
        filepath: {
            type: String,
            required: true,
        },
        total_rows_in_csv: {
            type: Number,
            default: 0
        },
        total_lines_in_csv: {
            type: Number,
            default: 0
        },
        total_orders_in_csv: {
            type: Number,
            default: 0
        },
        total_lines_in_system: {
            type: Number,
            default: 0
        },
        no_inventory_items: {
            type: Array,
            default: () => []
        },
        not_existing_items: {
            type: Array,
            default: () => []
        },
        autocheckout: {
            type: Boolean,
            default: 0
        }
    });

    const form = useForm({
        filepath: filepath,
        autocheckout: autocheckout,
        source: import.meta.env.VITE_CSV_UPLOAD_SOURCE
    })

    const continueUploadCsv = async (event) => {
        setOverlayMessage('Your file is being processed. Please do not refresh or close this page until the process is complete');
        if(form.processing) return;
        form.post(route('csv-upload.create'), {
            onFinish: () => {
                setOverlayMessage(null);
            },
        })      
    };

</script>
